/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import useRootStore from '@store/useRootStore'
import { SimpleClubInfoItem } from '@store/clubStore'
//img
// import superiorClubBadgeIco from '@assets/images/icon/club_icon/superior-club-badge-ico.png'
import clubEmblemAlternateImg from '@assets/images/icon/logo-shield-cool-gray-club.png'
// import clubPortalCopyDummyImg from '@assets/images/bg/club-portal/club-portal-copy-dummy.png'
// icon
import { ArrowIco } from '@shared/Icon/ArrowIcon'
// css
import { Button } from '@styles/button.style'
import { ClubSignature, ShowDetail } from '../index.style'

interface ClubCardProps {
  currentClubId?: string
  signedin: boolean
  club: SimpleClubInfoItem
  onClickMatchup: (id: string) => void
  onClickShowDetail: (club: SimpleClubInfoItem) => void
}

const ClubPortal: React.FC<ClubCardProps> = (props: ClubCardProps) => {
  const { globalStore, authStore, matchupStore } = useRootStore()
  const { currentClubId, /* signedin,*/ club, onClickMatchup, onClickShowDetail } = props
  const {
    id,
    name,
    notice,
    emblemImageUrl,
  } = club

  let eleNoticeTitle = ''
  let eleNoticeText = ''

  if (notice) {
    eleNoticeTitle = notice.title
    eleNoticeText = notice.contents
  }

  const applyDefaultEmblem = e => {
    e.target.src = clubEmblemAlternateImg
  }

  // const applyDefaultCopy = e => {
  //   e.target.src = clubPortalCopyDummyImg
  // }

  const ClubLisItemContents = (
    <Fragment>
      <ClubSignature className="club-signature">
        {/* 기획 변경으로 주석처리 [이슈링크](https://task.zempublic.co.kr/view.php?id=9798) */}
        {/*{!authStore.isSpecificClubMember && isRecommendClub && (*/}
        {/*  <img src={superiorClubBadgeIco} alt="우수클럽배지" className="badge" />*/}
        {/*)}*/}
        <div className="img-wrap">
          <img src={emblemImageUrl} onError={applyDefaultEmblem} alt="클럽 엠블럼"
               className={emblemImageUrl ? 'emblem' : 'emblem alternate-emblem'} />
        </div>
      </ClubSignature>

      <div className="club-info">
        <h2 className="club-name">{name}</h2>
        {/* 기획 변경으로 주석처리 [이슈링크](https://task.zempublic.co.kr/view.php?id=9798) */}
        {/*<img src={copyImageUrl} alt="" onError={applyDefaultCopy} className="club-info--copy-img" />*/}
        <div className="club-info--notice">
          <ShowDetail onClick={e => {
            onClickShowDetail(club)
          }}>
            <span className="club-info--notice--tit">{eleNoticeTitle}</span>
            <span className="club-info--notice--contents">{eleNoticeText}</span>
            <Button className="club-info--notice--btn more">
              <span>상세보기</span>
              <ArrowIco />
            </Button>
          </ShowDetail>
          {!authStore.isSpecificClubMember && (
            <Button
              className={currentClubId === id && !authStore.isSpecificClubMember ? 'club-info--notice--btn go-club current-club' : 'club-info--notice--btn go-club'}
              onClick={e => {
                e.stopPropagation()
                matchupStore.resetClubInfo()
                matchupStore.resetMatchTabSelection()
                matchupStore.resetTournamentFilterList()
                matchupStore.setPageType(undefined)
                matchupStore.setMatchTabInitializeMajorUniqueId(undefined)
                matchupStore.setMatchTabInitializeSportId(undefined)
                globalStore.resetGeneralPopupProperties()
                onClickMatchup(id)
                globalStore.setVisibleMatchFilterPopup(false)
              }}
            >
              {currentClubId === id && !authStore.isSpecificClubMember ?
                <Fragment>
                  <span className="current btn-txt">현재 클럽</span>
                  <ArrowIco />
                </Fragment> :
                <Fragment>
                  <span className="go-club btn-txt">클럽 이동</span>
                  <ArrowIco />
                </Fragment>
              }
              {/*<span className="go-club btn-txt">*/}
              {/*  <span>클럽 이동</span>*/}
              {/*  <ArrowIco />*/}
              {/*</span>*/}
              {/*<span className="current btn-txt">*/}
              {/*  <span>현재 클럽</span>*/}
              {/*  <ArrowIco />*/}
              {/*</span>*/}
            </Button>
          )}
        </div>
      </div>
    </Fragment>
  )

  return (
    <div className="club-portal-list--item">
      {ClubLisItemContents}
    </div>
  )
}

export default ClubPortal
